import React from "react";
import "./footer.scss";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

export default function Footer() {
    return (
        <footer className="footer">
            <Container>
                <Row className="footer-top gy-5">
                    <Col lg={4} md={12} className="footer-brand">
                        <p className="footer-name">Yacht Mumbai</p>
                        <p className="footer-blurb">Experience luxury on the Arabian Sea with Mumbai's premier yacht and speed boat charter service.</p>
                    </Col>
                    <Col lg={{ span: 2, offset: 1 }} sm={4} xs={6} className="footer-col">
                        <p className="footer-heading">Quick Links</p>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/full-fleet">Our Fleet</Link></li>
                            <li><HashLink to="/#experiences">Experiences</HashLink></li>
                            <li><Link to="/safety-guidelines">Safety</Link></li>
                            <li><HashLink to="/#contact">Contact</HashLink></li>
                        </ul>
                    </Col>
                    <Col lg={3} sm={4} xs={6} className="footer-col">
                        <p className="footer-heading">Services</p>
                        <ul>
                            <li><Link to="/full-fleet?category=sail_yachts_tab">Luxury Yacht Charters</Link></li>
                            <li><Link to="/full-fleet?category=speed_boats_tab">Speed Boat Rentals</Link></li>
                            <li><HashLink to="/#experiences">Sunset Cruises</HashLink></li>
                            <li><HashLink to="/#experiences">Corporate Events</HashLink></li>
                            <li><HashLink to="/#experiences">Private Celebrations</HashLink></li>
                            <li><HashLink to="/#experiences">Wedding Proposals</HashLink></li>
                        </ul>
                    </Col>
                    <Col lg={2} sm={4} xs={12} className="footer-col">
                        <p className="footer-heading">Connect With Us</p>
                        <ul>
                            <li><a href="tel:+919920088412">+91 99200 88412</a></li>
                            <li><a href="https://wa.me/919920088412" target="_blank" rel="noreferrer">WhatsApp</a></li>
                            <li><a href="mailto:info@yachtmumbai.in">info@yachtmumbai.in</a></li>
                        </ul>
                    </Col>
                </Row>

                <div className="bottom-footer">
                    <p>© {new Date().getFullYear()} Yacht Mumbai. All rights reserved.</p>
                    <ul>
                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                        <li><Link to="/terms-of-use">Terms of Use</Link></li>
                        <li><Link to="/safety-guidelines">Safety Guidelines</Link></li>
                    </ul>
                </div>
            </Container>
        </footer>
    );
}
